import { defineAction, number, object } from '~/prix'
import monitorWeeklyEmailSubscribersCountAction from './monitorWeeklyEmailSubscribersCount.action.json'

const monitorWeeklyEmailSubscribersCountDefinition = defineAction({
  ...monitorWeeklyEmailSubscribersCountAction,
  input: object({}),
  output: number(),
})

export default monitorWeeklyEmailSubscribersCountDefinition
